// #1307 — the field-sources projection keys engine rows as `engine#N:column`
// (N = inventory_links.position, the index the merge writes) while the canvas
// form holds them at `engines.N.column`. These two functions are the ONLY
// place the two shapes meet. Assumption pinned by CanvasEnginesSection's
// provenance test: the N-th canvas row is link position N (the API orders
// engines by position and the merge/save renumber them 0..n-1). An unsaved
// delete shifts the rows, so CanvasEnginesSection's remove handler renumbers
// the `_provenance` engine keys in step.

export const ENGINE_PROVENANCE_COLUMNS = [
  'engine_manufacturer',
  'engine_model',
  'engine_horsepower',
  'engine_year',
  'engine_hours',
  'engine_serial_number',
  'drive_type',
  'fuel_type',
] as const;

export type EngineProvenanceColumn = (typeof ENGINE_PROVENANCE_COLUMNS)[number];

const KEY = new RegExp(`^engine#(\\d+):(${ENGINE_PROVENANCE_COLUMNS.join('|')})$`);

export function engineProvenanceKey(index: number, column: EngineProvenanceColumn): string {
  return `engine#${index}:${column}`;
}

/** `engine#N:column` → `engines.N.column`; null for any key that is not an engine provenance key. */
export function engineFormPath(key: string): string | null {
  const match = KEY.exec(key);
  if (!match) return null;
  return `engines.${Number(match[1])}.${match[2]}`;
}
